



















































































import Vue from 'vue';

interface FormValues {
  current: string;
  next: string;
  confirm: string;
}

export default Vue.extend({
  data() {
    return {
      busy: false,
      form: this.$form.createForm(this),
    };
  },

  methods: {
    checkNewPassword(
      rule: any,
      val: string,
      callback: (message?: string) => void,
    ) {
      const { getFieldValue } = this.form;
      if (!val) {
        callback('Passwords does not match.');
        return;
      }

      if (val !== getFieldValue('next')) {
        callback('Passwords does not match.');
        return;
      }

      callback();
      return;
    },

    handleSubmit() {
      this.form.validateFields((errors: Error[], values: FormValues) => {
        if (errors === null) {
          this.$coreApp.auth.changePassword(
            values.current,
            values.next,
            (err, res, loading) => {
              this.busy = loading;

              if (!loading && err) {
                this.$message.error(
                  `Unable to change password: ${err.message}`,
                );
              } else if (!loading && !err) {
                this.$message.success(`Password changed successfully.`);
              }
            },
          );
        }
      });
    },
  },
});
